export default __webpack_public_path__ + "static/media/vishnu.a9dc3a6f.png";